import React, { Component } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { API_URL } from '../../partials/Globals';
import Errors from '../../partials/Errors';
import Message from '../../partials/Message';
import Icon from '../../partials/Icon';
import Student from './Student';
import Lightbox from '../../partials/Lightbox';

export default class Group extends Component {
    state = {
        group: {
            id: '',
            name : '',
            school_id: ''
        },
        message: '',
        lightbox: false
    }

    constructor(props) {
        super(props);

        this.fetch = this.fetch.bind(this);
        this.toggleLightbox = this.toggleLightbox.bind(this);
    }

    componentDidMount() {
        this.fetch();
    }

    fetch() {
        axios.get(API_URL+'/admin/groups/'+this.props.match.params.id)
            .then(response => {
                this.setState({ group: response.data });
            });
    }

    toggleLightbox() {
        this.setState({ lightbox: (this.state.lightbox === true ? false: true) });
    }

    render() {
        const { group } = this.state;
        const self = this;

        return (
            <div>
                <Lightbox open={ this.state.lightbox } toggle={ this.toggleLightbox } contents={ <div><h3>Projekt</h3><p>Klicka på ett projekt för att se mer och bl a se fördelning av andelar.</p><hr /><h3>Deltagare</h3><p>Klicka på en deltagare för att redigera uppgifter. Deltagarens inloggningskod ligger högerställd i listan.</p></div> } />

                <div className="top">
                    <div className="col-12">
                        <button className="back" onClick={ this.props.history.goBack }>Tillbaka</button>
                        <button className="lightbox-toggle" onClick={ this.toggleLightbox }></button>
                    </div>
                </div>

                <Errors errors={ this.state.errors } />
                <Message message={ this.state.message } />

                <div className="container">
                    <div className="content">
                        <h1>{ group.name }</h1>

                        <div className="block">
                            <div className="header">
                                <h4>Projekt</h4>
                            </div>
                            <div className="body">
                                { (group.projects && group.projects.length > 0) ? (
                                    <ul className="has-icons">
                                        { Object.keys(group.projects).map(function(key) {
                                            return (
                                                <li key={ key }>
                                                    <Icon icon="project" color="pink" />
                                                    <Link to={ `/admin/projects/${ group.id }/${ group.projects[key].id }` }>{ group.projects[key].title }</Link>
                                                </li>
                                            )
                                        })}
                                    </ul>
                                ) : (
                                    <span>Det finns inga projekt kopplade till denna grupp.</span>
                                ) }
                            </div>
                        </div>

                        <div className="block">
							<div className="block-top-link">
								<Link to={ `/admin/students/add/${ group.id }` }>
									<span>Lägg till deltagare</span>
									<span className="add-icon">+</span>
								</Link>
							</div>

							<div className="header">
								<h4>Deltagare</h4>
								<span>Inloggningskoder</span>
							</div>

							<div className="body">
                                { (group.students && group.students.length > 0) ? (
                                    <ul className="has-icons">
                                        { Object.keys(group.students).map(function(key) {
                                            return (
                                                <Student key={ key } student={ group.students[key] } group_id={ group.id } update={ self.fetch } />
                                            )
                                        })}
                                    </ul>
                                ) : (
                                    <span>Det finns inga deltagare.</span>
                                ) }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/admin/Group/index.js